import { render, staticRenderFns } from "./RealVideoFrame.vue?vue&type=template&id=04f1a532&scoped=true"
import script from "./RealVideoFrame.vue?vue&type=script&lang=js"
export * from "./RealVideoFrame.vue?vue&type=script&lang=js"
import style0 from "./RealVideoFrame.vue?vue&type=style&index=0&id=04f1a532&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f1a532",
  null
  
)

export default component.exports